import { createLogic, StandardAction } from "redux-logic";
import {
  SET_AFRAME_BOX,
  FETCH_AFRAME_REVIEW_BOX,
  clearReviewBoxData,
  setReviewBoxData,
  setIPackBoxBarcode,
  verifyRxBagsRequired,
} from "../reducers/aFrameReviewBoxReducer";
import { setError, setLoadingStatus } from "../reducers/applicationStateReducer";
import { PayloadWrapper } from "../types/PayloadWrapper";
import Endpoints from "../../../lib/aframeboxlookup/Endpoints";
import ReviewBox from "../../../lib/aframeboxlookup/AFrameReviewBox";
import {
  setAFrameAction,
  setAframeReviewWarning,
  toggleScanDisabled,
} from "../reducers/aframeModeReducer";
import AFrameConstants from "../../aframeboxlookup/Constants";
import { CancellationReason } from "../../rxAutoMessages/rxAutoMessages";
import SortBoxEndpoints from "../../sortbox/SortBoxEndpoints";
const { ActionStates, SortBoxDivertReason } = AFrameConstants;
const setAFrameReviewBoxLogic = createLogic({
  type: SET_AFRAME_BOX,
  async process(
    {
      action,
    }: {
      getState: any;
      action: StandardAction<
        string,
        { reviewBox: any; aFrameAction: number; focusCallback: () => void }
      >;
    },
    dispatch,
    done
  ) {
    if (
      action.payload.reviewBox.boxItems.length == 0 &&
      action.payload.aFrameAction === ActionStates.PUTAWAY_STOCK
    ) {
      switch (action.payload.reviewBox.cancellationReason) {
        case CancellationReason.BoxRedirectToCheckstationCancelOrder: //todo ta bort senare
        case CancellationReason.BoxRedirectToCheckstationCancelDelivery: {
          await SortBoxEndpoints.deleteSortBoxAndRxChildren(action.payload.reviewBox.boxID, true)
            .then(() => {
              dispatch(setAFrameAction(new PayloadWrapper(ActionStates.BOX_LOADED)));
            })
            .catch((e) => {
              dispatch(
                setError({
                  message: "Kunde inte stryka plocklista:" + e,
                  visible: true,
                  errorType: -1,
                })
              );
            })
            .finally(() => {
              done();
            });
          break;
        }
        case CancellationReason.BoxRedirectToCheckstationCancelOrder:
          break;
        default: {
          console.log(`Unknow cancellation!: ${action.payload.reviewBox.cancellationReason}.`);
          dispatch(
            setError({
              message: "Lagerflytt färdig, ordern/påsen behöver hanteras manuellt.",
              visible: true,
              errorType: -1,
            })
          );
          done();
        }
      }
    } else {
      dispatch(setLoadingStatus(new PayloadWrapper(false)));
      dispatch(setAFrameAction(new PayloadWrapper(action.payload.aFrameAction)));
      dispatch(toggleScanDisabled(new PayloadWrapper(false)));
    }

    action.payload.focusCallback();
    done();
  },
});

const fetchAFrameReviewBoxLogic = createLogic({
  type: FETCH_AFRAME_REVIEW_BOX,
  async process(
    {
      getState,
      action,
    }: {
      getState: any;
      action: StandardAction<
        string,
        {
          type: number;
          input: string;
          errorCallback: (input: string) => void;
          focusCallback: () => void;
        }
      >;
    },
    dispatch,
    done
  ) {
    dispatch(clearReviewBoxData());
    dispatch(setLoadingStatus(new PayloadWrapper(true)));
    dispatch(toggleScanDisabled(new PayloadWrapper(true)));
    dispatch(setIPackBoxBarcode(new PayloadWrapper(action.payload.input)));
    const state = getState();
    const checkStation = state.aframeModeReducer.aFrameControlStationType;
    await Endpoints.getAFrameReviewBox(action.payload.type, action.payload.input, checkStation)
      .then((rb: any) => {
        if (rb.notFound) {
          dispatch(setLoadingStatus(new PayloadWrapper(false)));
          dispatch(toggleScanDisabled(new PayloadWrapper(false)));
          action.payload.errorCallback("Kunde inte hitta order!");
          done();
        } else {
          const reviewBox = new ReviewBox(rb);
          reviewBox.load(checkStation);
          if (
            (reviewBox.data as any).warnings.some((x:any) => x.divertReason === SortBoxDivertReason.APOTEA_RX_BOX_INSPECTION_REQUIRED)
          ) {
            dispatch(verifyRxBagsRequired(new PayloadWrapper(true)));
          }

          const statuses = [
            CancellationReason.BoxRedirectToCheckstationCancelOrder,
            CancellationReason.BoxRedirectToCheckstationCancelDelivery,
          ];
          let showPutawayStockMode =
            statuses.includes((reviewBox.data as any).cancellationReason) && checkStation === 3;
          var aFrameAction = reviewBox.containsUnpicked
            ? ActionStates.COMPLETE_BOX
            : ActionStates.LOAD_BOX;
          if (showPutawayStockMode && (reviewBox.data as any).boxItems.length > 0) {
            aFrameAction = ActionStates.PUTAWAY_STOCK;
            dispatch(
              setAframeReviewWarning(
                new PayloadWrapper(
                  _getCancellationReasonText((reviewBox.data as any).cancellationReason)
                )
              )
            );
          } else if (
            (reviewBox.data as any).cancellationReason ==
              CancellationReason.BoxRedirectToCheckstation &&
            checkStation === 3
          ) {
            dispatch(
              setAframeReviewWarning(
                new PayloadWrapper(
                  _getCancellationReasonText((reviewBox.data as any).cancellationReason)
                )
              )
            );
          } else dispatch(setAframeReviewWarning(new PayloadWrapper(null)));
          dispatch(
            setReviewBoxData({
              reviewBox: reviewBox.data,
              aFrameAction,
              focusCallback: action.payload.focusCallback,
            })
          );
          const operatorId = state.loginInfoReducer.operatorID;
          const sortboxId = reviewBox.data["boxID" as keyof object];
          Endpoints.setAFrameControlledBy(operatorId, sortboxId, checkStation);
          dispatch(toggleScanDisabled(new PayloadWrapper(false)));
          done();
        }
      })
      .catch((ex: any) => {
        console.log(ex);
        dispatch(setLoadingStatus(new PayloadWrapper(false)));
        dispatch(toggleScanDisabled(new PayloadWrapper(false)));
        dispatch(clearReviewBoxData());

        action.payload.errorCallback("Kunde inte ladda order!");
        done();
      });
  },
});

function _getCancellationReasonText(reason: CancellationReason): string {
  switch (reason) {
    case CancellationReason.NonRxOrderIncomplete:
      return "Ej färdig icke rxorder";
    case CancellationReason.BoxRedirectToCheckstation:
      return "Lådan har skickats till kontrollstation av farmaceut.";
    case CancellationReason.BoxRedirectToCheckstationCancelOrder:
    case CancellationReason.BoxRedirectToCheckstationCancelDelivery:
      return "Utleveransen ska avbrytas. Scanna artiklarna till lagerback och ta bort lådan.";
    default:
      return "Lådan har avbrutits vid rx-station";
  }
}

export { setAFrameReviewBoxLogic, fetchAFrameReviewBoxLogic };
